import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { TemplateMasterDataType } from '../../@types/templateMasterDataType';
import URLConstants from '../../constants/urlConstants';


type TemplateMasterDataState = {
    isLoading: boolean;
    error: boolean;
    templateMasterData: TemplateMasterDataType;
}

const initialState: TemplateMasterDataState = {
    isLoading: false,
    error: false,
    templateMasterData: {} as TemplateMasterDataType
}

const slice = createSlice({
    name: 'templateMasterData',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET TEMPLATE MASTER DATA
        getTemplateMasterDataSuccess(state, action) {
            state.isLoading = false;
            state.templateMasterData = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getTemplateMasterData() {
        return async () => {
            dispatch(slice.actions.startLoading());
            try {
                const response = await axios.get(URLConstants.TEMPLATE_MASTER_DATA_BASE_URL,);
                dispatch(slice.actions.getTemplateMasterDataSuccess(response.data.data));
            } catch (error) {
                dispatch(slice.actions.hasError(error));
            }
        };
  
}

export function deleteTemplate(whatsAppBusinessId:string, template_name:string) {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.delete(URLConstants.TEMPLATE_DELETE_BASE_URL,{data:{'whatsAppBusinessId':whatsAppBusinessId, 'template_name':template_name}});
            dispatch(slice.actions.getTemplateMasterDataSuccess(response.data.data));
        }catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}

